import Vuex from 'vuex';

import Module from './Module';
import Interface, { createCustomInterface } from './Interface';

import PagePool from './PagePoolModule';

let Vue;

let modules = {};

let interfaces = {};

let plugins;

let templateFunctions = {};

let customStuff = {
    modules: {},
    interfaces: [],
};

function install(_Vue) {
    if (Vue && _Vue === Vue) {
        if (process.env.NODE_ENV !== 'production') {
            console.error(
                '[RestX] already installed. Vue.use(RestX) should be called only once.'
            );
        }
        return;
    }
    Vue = _Vue;
    Vue.use(Vuex);
}

/**
 * createTemplateFunctions({
 *      setCookie(token): asdasd
 *      retrieveCoockie(): return token
 * })
 */
function registerTemplateFunctions(config) {
    templateFunctions = config;
}

/**
 * createPlugins([
 *      {
 *          storage: window.localStorage,
 *          modules: ['user']
 *      }
 * ])
 */
function registerPlugins(arrayOfPlugins) {
    plugins = arrayOfPlugins;
}

function createCustomModule(namespace, description) {
    customStuff.modules[namespace] = {
        namespaced: true,
        ...description,
    };
    customStuff.interfaces.push({ namespace, description });
}

function createStore(branches = {}, logger = { log() {}, error() {} }) {
    let branchEntries = Object.entries(branches);
    modules = { ...modules, ...generateModules(branchEntries, logger) };

    // console.log(plugins);

    let store = new Vuex.Store({
        modules: {
            ...((customStuff || {}).modules || {}),
            ...modules,
            pagePool: PagePool || {},
        },
        plugins: plugins || [],
    });
    interfaces = {
        ...interfaces,
        ...generateInterfaces(branchEntries, store, logger),
    };
    customStuff.interfaces.forEach(({ namespace, description }) => {
        interfaces[namespace] = createCustomInterface(
            store,
            namespace,
            description
        );
    });
    if (Vue) Vue.prototype.$interfaces = interfaces;
    return store;
}

const generateModules = (branchEntries, logger) =>
    branchEntries
        .map(([k, v]) => [k, Module(v, logger, templateFunctions)])
        .reduce(objectFromEntries, {});

const generateInterfaces = (branchEntries, store, logger) =>
    branchEntries
        .map(([k, v]) => [k, new Interface(store, k, v, null, null, logger)])
        .reduce(objectFromEntries, {});

const objectFromEntries = (acc, [k, v]) => ({ ...acc, [k]: v });

const getInterfaces = () => interfaces;

export default {
    install,
    createStore,
    modules,
    getInterfaces,
    registerTemplateFunctions,
    registerPlugins,
    createCustomModule,
};
